import React, { useState } from 'react';
import { useAuth } from '../AuthContext.js';
import axios from 'axios';

const LikeComponent = ({ likes, userId, reviewId }) => {
  const {loggedIn} = useAuth();
  const [likeArray, setLikes] = useState(likes);
  const likeArrayCopy = likeArray;
  const handleButtonClick = async () => {
    if (!likeArray.includes(userId)) {
        likeArrayCopy.push(userId)
        console.log(likeArrayCopy)
        setLikes(likeArrayCopy);

    } else {
      // likeArrayCopy.filter((element) => element !== userId)
      const index = likeArrayCopy.indexOf(userId);
      if (index > -1) { // only splice array when item is found
        likeArrayCopy.splice(index, 1); // 2nd parameter means remove one item only
      }
      setLikes(likeArrayCopy)   
    }
    const response = await axios.put(`https://uplbidet-api.vercel.app/api/reviews/${reviewId}`, {likes:likeArrayCopy})
    setLikes(response.data.likes)
  };

  return (
    <span>
      <div className="label-button" onClick={handleButtonClick} style={{ display: loggedIn ? 'block' : 'none' }}>
        LIKE ({ likeArray.length })   
      </div>
    </span>
  );
};  

export default LikeComponent;
